// @ts-nocheck
import get from 'lodash/get';
import { createWriteStream } from 'app/utils/streamsaver';
import {
  AF_COUNTRY,
  AF_REGION,
  AF_BUDGET,
  AF_TRANSACTION,
  AF_SECTOR,
  AF_TRANSACTION_PROVIDER_ORG_REF,
  AF_PARTICIPATING_ORG_REF,
  AF_REPORTING_ORG_REF,
  AF_ACTIVITY_STATUS_CODE,
  AF_ACTIVITY_SCOPE_CODE,
  AF_HUMANITARIAN_SCOPE_VOCABULARY,
  AF_HUMANITARIAN_SCOPE_TYPE,
  AF_TRANSACTION_RECEIVER_ORG_REF,
  AF_REPORTING_ORG_TYPE_CODE,
  AF_REPORTING_ORG_SECONDARY_REPORTER,
  AF_SECTOR_VOCABULARY,
  AF_TRANSACTION_FLOW_TYPE_CODE,
  AF_TRANSACTION_TIED_STATUS_CODE,
  AF_TRANSACTION_HUMANITARIAN,
  AF_TRANSACTION_TYPE_CODE,
  AF_TRANSACTION_VALUE_CURRENCY,
  AF_COUNTRY_NAME,
  AF_COUNTRY_PERC,
  AF_TITLE_NARRATIVE,
  AF_IATI_IDENTIFIER,
  AF_RESULT_TYPE,
  AF_RESULT_TITLE_NARRATIVE,
  AF_ACTIVITY_DATE_ISO_DATE,
  AF_ACTIVITY_DATE_TYPE,
  AF_ACTIVITY_DATE_START_ACTUAL,
  AF_ACTIVITY_DATE_START_PLANNED,
  AF_ACTIVITY_DATE_END_ACTUAL,
  AF_ACTIVITY_DATE_END_PLANNED,
  AF_DESCRIPTION_NARRATIVE,
  AF_DESCRIPTION_TYPE,
  AF_HUMANITARIAN,
  AF_HUMANITARIAN_SCOPE_NARRATIVE,
  AF_HUMANITARIAN_SCOPE_VOCABULARY_URI,
  AF_LAST_UPDATED_DATETIME,
  AF_PARTICIPATING_ORG_NARRATIVE,
  AF_PARTICIPATING_ORG_NARRATIVE_LANG,
  AF_PARTICIPATING_ORG_NARRATIVE_TEXT,
  AF_PARTICIPATING_ORG_ROLE,
  AF_PARTICIPATING_ORG_TYPE,
  AF_REGION_NAME,
  AF_REGION_PERC,
  AF_REGION_VOCABULARY,
  AF_REGION_VOCABULARY_URI,
  AF_REPORTING_ORG_NARRATIVE,
  AF_REPORTING_ORG_TYPE_NAME,
  AF_SECTOR_NARRATIVE,
  AF_SECTOR_PERC,
  AF_SECTOR_VOCABULARY_URI,
  AF_TRANSACTION_REF,
  AF_TRANSACTION_DATE_ISO_DATE,
  AF_TRANSACTION_VALUE_DATE,
  AF_TRANSACTION_VALUE,
  AF_TRANSACTION_VALUE_USD_CONVERSION_RATE,
  AF_TRANSACTION_PROVIDER_ORG_PROVIDER_ACTIVITY_ID,
  AF_TRANSACTION_PROVIDER_ORG_TYPE,
  AF_TRANSACTION_PROVIDER_ORG_NARRATIVE_TEXT,
  AF_TRANSACTION_RECEIVER_ORG_RECEIVER_ACTIVITY_ID,
  AF_TRANSACTION_RECEIVER_ORG_TYPE,
  AF_TRANSACTION_RECEIVER_ORG_NARRATIVE,
  AF_TRANSACTION_DISBURSEMENT_CHANNEL_CODE,
  AF_TRANSACTION_SECTOR_VOCABULARY,
  AF_TRANSACTION_SECTOR_CODE,
  AF_TRANSACTION_COUNTRY,
  AF_TRANSACTION_REGION,
  AF_TRANSACTION_FINANCE_TYPE_CODE,
  AF_TRANSACTION_AID_TYPE_CODE,
  AF_TRANSACTION_AID_TYPE_VOCABULARY,
  AF_TRANSACTION_DESCRIPTION_NARRATIVE,
} from 'app/utils/getAPIFormattedFilters';

const sortKeys = {
  'Start date asc': 'activity_date_start_actual asc',
  'Start date desc': 'activity_date_start_actual desc',
  'End date asc': 'activity_date_end_actual asc',
  'End date desc': 'activity_date_end_actual desc',
  'Start date planned desc': 'activity_date_start_planned desc',
  'Status asc': `${AF_ACTIVITY_STATUS_CODE} asc`,
  'Status desc': `${AF_ACTIVITY_STATUS_CODE} desc`,
  'Organisation asc': 'index asc',
  'Organisation desc': 'index desc',
  'Publisher asc': 'index asc',
  'Publisher desc': 'index desc',
  'Donor asc': 'index asc',
  'Donor desc': 'index desc',
  'Activities count asc': 'count asc',
  'Activities count desc': 'count desc',
  'IATI ref asc': 'index asc',
  'IATI ref desc': 'index desc',
};

const fields = `${AF_IATI_IDENTIFIER},${AF_TITLE_NARRATIVE},${AF_ACTIVITY_STATUS_CODE},${AF_COUNTRY},${AF_COUNTRY_NAME},${AF_COUNTRY_PERC},${AF_RESULT_TYPE},${AF_RESULT_TITLE_NARRATIVE},${AF_ACTIVITY_DATE_ISO_DATE},${AF_ACTIVITY_DATE_TYPE},${AF_ACTIVITY_DATE_START_ACTUAL},${AF_ACTIVITY_DATE_START_PLANNED},${AF_ACTIVITY_DATE_END_ACTUAL},${AF_ACTIVITY_DATE_END_PLANNED},${AF_ACTIVITY_SCOPE_CODE},${AF_DESCRIPTION_NARRATIVE},${AF_DESCRIPTION_TYPE},${AF_HUMANITARIAN},${AF_HUMANITARIAN_SCOPE_TYPE},${AF_HUMANITARIAN_SCOPE_NARRATIVE},${AF_HUMANITARIAN_SCOPE_TYPE},${AF_HUMANITARIAN_SCOPE_VOCABULARY},${AF_HUMANITARIAN_SCOPE_VOCABULARY_URI},${AF_LAST_UPDATED_DATETIME},${AF_PARTICIPATING_ORG_NARRATIVE},${AF_PARTICIPATING_ORG_NARRATIVE_LANG},${AF_PARTICIPATING_ORG_NARRATIVE_TEXT},${AF_PARTICIPATING_ORG_REF},${AF_PARTICIPATING_ORG_ROLE},${AF_PARTICIPATING_ORG_TYPE},${AF_REGION},${AF_REGION_NAME},${AF_REGION_PERC},${AF_REGION_VOCABULARY},${AF_REGION_VOCABULARY_URI},${AF_REPORTING_ORG_NARRATIVE},${AF_REPORTING_ORG_REF},${AF_REPORTING_ORG_SECONDARY_REPORTER},${AF_REPORTING_ORG_TYPE_CODE},${AF_REPORTING_ORG_TYPE_NAME},${AF_SECTOR},${AF_SECTOR_NARRATIVE},${AF_SECTOR_PERC},${AF_SECTOR_VOCABULARY},${AF_SECTOR_VOCABULARY_URI},${AF_BUDGET}`;
const activityTransactionsFields = `${AF_IATI_IDENTIFIER},${AF_REPORTING_ORG_REF},${AF_TITLE_NARRATIVE},${AF_DESCRIPTION_NARRATIVE},${AF_COUNTRY},${AF_REGION},${AF_SECTOR},${AF_TRANSACTION_REF},${AF_TRANSACTION_HUMANITARIAN},${AF_TRANSACTION_TYPE_CODE},${AF_TRANSACTION_DATE_ISO_DATE},${AF_TRANSACTION_VALUE_CURRENCY},${AF_TRANSACTION_VALUE_DATE},${AF_TRANSACTION_VALUE},${AF_TRANSACTION_VALUE_USD_CONVERSION_RATE},${AF_TRANSACTION},${AF_TRANSACTION_PROVIDER_ORG_REF},${AF_TRANSACTION_PROVIDER_ORG_PROVIDER_ACTIVITY_ID},${AF_TRANSACTION_PROVIDER_ORG_TYPE},${AF_TRANSACTION_PROVIDER_ORG_NARRATIVE_TEXT},${AF_TRANSACTION_RECEIVER_ORG_REF},${AF_TRANSACTION_RECEIVER_ORG_RECEIVER_ACTIVITY_ID},${AF_TRANSACTION_RECEIVER_ORG_TYPE},${AF_TRANSACTION_RECEIVER_ORG_NARRATIVE},${AF_TRANSACTION_DISBURSEMENT_CHANNEL_CODE},${AF_TRANSACTION_SECTOR_VOCABULARY},${AF_TRANSACTION_SECTOR_CODE},${AF_TRANSACTION_COUNTRY},${AF_TRANSACTION_REGION},${AF_TRANSACTION_FLOW_TYPE_CODE},${AF_TRANSACTION_FINANCE_TYPE_CODE},${AF_TRANSACTION_AID_TYPE_CODE},${AF_TRANSACTION_AID_TYPE_VOCABULARY},${AF_TRANSACTION_TIED_STATUS_CODE},${AF_TRANSACTION_DESCRIPTION_NARRATIVE}`;

function getQuery(filters: any, search: string, searchFields: string[]) {
  const filterKeys = Object.keys(filters);
  if (filterKeys.length === 0 && search.length === 0) {
    return '*:*';
  }

  let query = '';

  if (filterKeys.length > 0) {
    filterKeys.forEach((filterKey: string, index: number) => {
      if (filterKey === AF_BUDGET) {
        query += `${filterKey}:[${filters[filterKey].join(' TO ')}]${
          index === filterKeys.length - 1 ? '' : ' AND '
        }`;
      } else if (filterKey === 'period') {
        const dates = [
          new Date(filters[filterKey][0].startDate).toISOString(),
          new Date(filters[filterKey][0].endDate).toISOString(),
        ];
        query += `(activity_date_start_actual_f: [${
          dates[0]
        } TO *] OR activity_date_start_planned_f: [${
          dates[0]
        } TO *]) AND (activity_date_end_actual_f: [* TO ${
          dates[1]
        }] OR activity_date_end_planned_f: [* TO ${dates[1]}])${
          index === filterKeys.length - 1 ? '' : ' AND '
        }`;
      } else if (filterKey === 'year_period') {
        query += `(activity_date_start_actual_f:[${
          filters[filterKey]
        }-01-01T00:00:00Z TO ${
          filters[filterKey]
        }-12-31T23:59:59Z] OR activity_date_start_planned_f:[${
          filters[filterKey]
        }-01-01T00:00:00Z TO ${filters[filterKey]}-12-31T23:59:59Z])${
          index === filterKeys.length - 1 ? '' : ' AND '
        }`;
      } else if (filterKey === AF_COUNTRY) {
        query += `(${filterKey}:(${filters[filterKey].join(
          ' '
        )}) OR transaction_recipient_country_code:(${filters[filterKey].join(
          ' '
        )}))${index === filterKeys.length - 1 ? '' : ' AND '}`;
      } else {
        query += `${filterKey}:(${filters[filterKey].join(' ')})${
          index === filterKeys.length - 1 ? '' : ' AND '
        }`;
      }
    });
  }

  if (search.length > 0 && filterKeys.length > 0) {
    query += ' AND (';
    query += searchFields
      .map((field: string) => `${field}:(${search})`)
      .join(' OR ');
    query += ')';
  }

  if (search.length > 0 && filterKeys.length <= 0) {
    query += searchFields
      .map((field: string) => `${field}:(${search})`)
      .join(' OR ');
  }

  return query;
}

function downloadFile(url: string, fileName: string) {
  return fetch(url)
    .then((res) => {
      const fileStream = createWriteStream(fileName);
      const writer = fileStream.getWriter();
      if (res.body.pipeTo && globalThis.WritableStream) {
        writer.releaseLock();
        return res.body.pipeTo(fileStream);
      }

      const reader = res.body.getReader();
      const pump = () =>
        reader
          .read()
          .then(({ value, done }) =>
            done ? writer.close() : writer.write(value).then(pump)
          );

      return pump();
    })
    .catch((error) => console.error(error));
}

export function downloadActivitiesCSV(
  filters: any,
  sort: string,
  search: string | undefined,
  count: number,
  ref?: string
): Promise<void> {
  const sortstring = get(
    sortKeys,
    `[${sort || 'Start date planned desc'}]`,
    ''
  );
  const query = getQuery(filters, search || '', [
    AF_COUNTRY,
    'title_narrative_text',
  ]);
  const refValue = ref ? `-${ref}` : '';
  const url = `https://iati.cloud/search/activity?q=${query}&sort=${sortstring}&rows=${count}&wt=csv&fl=${fields}`;
  return downloadFile(url, `aida-activities${refValue}.csv`);
}

export function downloadTransactionsCSV(
  activityRef: string,
  filter: string,
  count: number
): Promise<void> {
  const url = `https://iati.cloud/search/transaction?q=iati_identifier:${encodeURIComponent(
    activityRef
  )} AND ${filter}&rows=${count}&wt=csv&fl=${activityTransactionsFields}`;
  return downloadFile(url, `aida-transactions-${activityRef}.csv`);
}
